export const SCORE_TYPE = {
  CREDIT_RISK: 'CREDIT_RISK',
  PERFORMANCE: 'PERFORMANCE',
}

export const PERFORMANCE_SCORE_COLOR = [
  '#EB6671',
  '#FFDE86',
  '#C3D785',
  '#87D4A4',
]

export const STATUS_COLOR = {
  1: '#3DA967',
  2: '#E03643',
  3: '#EC626D',
  4: '#9C9C9C',
  8: '#D375AE',
  9: '#F58B00',
  10: '#3A414B',
  11: '#C8781A',
  12: '#E8B714',
}

export const SENTIMENT_TYPE = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  NEUTRAL: 'NEUTRAL',
}

export const SENTIMENT_TYPE_ID = {
  POSITIVE: 11,
  NEGATIVE: 9,
  NEUTRAL: 10,
}

export const SENTIMENT_TYPE_COLOR = {
  [SENTIMENT_TYPE_ID.POSITIVE]: '#3DA967',
  [SENTIMENT_TYPE_ID.NEGATIVE]: '#E0505B',
  [SENTIMENT_TYPE_ID.NEUTRAL]: '#E8B714',
}

export const ALERT_TYPE_CODE = {
  NEWS: {
    key: 'NEWS',
    dataKey: 'news',
  },
  CHANGEBASIC: {
    key: 'CHANGEBASIC',
    dataKey: 'changeBasic',
  },
  CHANGESTATUS: {
    key: 'CHANGESTATUS',
    dataKey: 'changeStatus',
  },
  CHANGEPERIOD: {
    key: 'CHANGEPERIOD',
    dataKey: 'changePeriod',
  },
  UPDATEFS: {
    key: 'UPDATEFS',
    dataKey: 'updateFS',
  },
  CHANGERFINANCIAL: {
    key: 'CHANGERFINANCIAL',
    dataKey: 'changeFinancial',
  },
  UPDATETAX: {
    key: 'UPDATETAX',
    dataKey: 'updateTax',
  },
  UPDATEINSURANCE: {
    key: 'UPDATEINSURANCE',
    dataKey: 'updateInsurance',
  },
  UPDATEINVOICE: {
    key: 'UPDATEINVOICE',
    dataKey: 'updateInvoice',
  },
  MANAGEMENTCHANGE: {
    key: 'MANAGEMENTCHANGE',
    dataKey: 'changeTableDataManagement',
  },
  OWNERSHIPCHANGE: {
    key: 'OWNERSHIPCHANGE',
    dataKey: 'changeTableDataOwnership',
  },
  INFOR: {
    key: 'INFOR',
    dataKey: 'info',
  },
  CHANGELIMITSCORE: {
    key: 'CHANGELIMITSCORE',
    dataKey: 'changeLimitScore',
  },
  MACROECONOMIC: {
    key: 'MACROECONOMIC',
    dataKey: 'macroeconomic',
  },
  INDUSTRY: {
    key: 'INDUSTRY',
    dataKey: 'industry',
  },
}
